import { IValues } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import { EField, IExtraData } from "./schema.tenantProfileBroker.types";

export const getInitialValues = ({ broker }: IExtraData): IValues => {
  return {
    [EField.IntakeMail]: broker.intakeMail || undefined,
    [EField.IntakeType]: broker.intakeType,
  };
};
